import { useMemo } from 'react';
import { IntlShape, useIntl } from 'react-intl';

const getVideoReplacementTpl = (videoLink: string | undefined, intl: IntlShape) => `<section class="consent-banner">
  <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"></path><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm1 7v6h-2v-6h2zm0-4v2h-2V7h2z" fill="currentColor" fill-rule="nonzero"></path></g></svg>
  <div class="content">
    <p>${intl.formatMessage({ id: 'JOBS_DETAIL_HTML_DESCRIPTION_NO_TRACKING_CONSENT_MESSAGE' })}</p>
    <p>
      <a href="${videoLink}" class="replace-link" target="_blank">
        ${intl.formatMessage({
          id: 'JOBS_DETAIL_HTML_DESCRIPTION_NO_TRACKING_CONSENT_LINK',
        })}
        <svg class="replace-link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <g fill="none" fill-rule="evenodd">
            <path d="M0 0h24v24H0z"></path>
            <path d="M10.2 6.6V9l-4.801-.001v9.6h9.6L15 13.8h2.4V21H3V6.6h7.2zM21 3v7.2h-2.4l-.001-3.052-7.268 7.268-1.697-1.697L16.953 5.4H13.8V3H21z" fill="currentColor" fill-rule="nonzero"></path>
          </g>
        </svg>
      </a>
    </p>
  </div>
</section>`;

const videoSectionRegEx = /<section class="video">\s*<iframe.*?src="(.*?)"[^>]*>\s*<\/iframe>\s*<\/section>/;

export function useVideoReplace(content: string | null | undefined): string {
  const intl = useIntl();

  return useMemo(() => {
    if (content) {
      const videoLink = videoSectionRegEx.exec(content)?.[1];

      return content.replace(videoSectionRegEx, getVideoReplacementTpl(videoLink, intl));
    }
    return '';
  }, [content, intl]);
}
